/** Training Keys from Class Details: one class's single-use keys. */
export const classTrainingKeysRoute = '/entitlements/classes/:classId/training-keys'

export function classTrainingKeysPath(classId: string): string {
  return `/entitlements/classes/${encodeURIComponent(classId)}/training-keys`
}

/** The API's class key endpoints. */
export function classKeysApi(classId: string): string {
  return `/entitlements/v1/classes/${encodeURIComponent(classId)}/training-keys`
}

export function eventKeyApi(classId: string): string {
  return `/entitlements/v1/classes/${encodeURIComponent(classId)}/event-key`
}
